/* eslint-disable */
export default {
  removeMeetingWarning:
    'Ajoitusominaisuus on poistettu käytöstä. Käytä sovellusta {app} videotapaamisten ajoittamiseen.',
  scheduleMeetingTips:
    'Huomaa, että tästä sovelluksesta on poistettu tapaamiset. {app} on suositeltava tapaamisiin.',
  migrateToPluginAlert:
    'Huomaa: Tämä sovellus ei toimi Outlook 2016:n tai sitä vanhempien versioiden eikä Internet Explorer 11:n kanssa. Päivitä Outlook tai vaihda Microsoft Edgeen, tai vaihtoehtoisesti vaihda sovellukseen {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
